module.exports = __webpack_public_path__ + "img/lg_ring_r_o_null_1@2x.ed0d19e8.png";